import Vue from 'vue';
import App from './App.vue';
import router from './router';
import PrimeComponent from './components/PrimeVue'
import KeycloakAuth from './auth/keycloakAuth';
import i18n from './i18n'
import VueClipboard from 'vue-clipboard2'

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(PrimeComponent);
Vue.prototype.$eventHub = new Vue(); // Global event bus

function startVue() {
  new Vue({
    router,
    i18n,
    render: h => h(App)
  }).$mount('#app');
}

const keycloakAuth = new KeycloakAuth(
    { 
      url: process.env.VUE_APP_KEYCLOAK_URL + "/auth", 
      realm: process.env.VUE_APP_KEYCLOAK_REALM, 
      clientId: process.env.VUE_APP_KEYCLOAK_CLIENT, 
      onLoad: "login-required" 
    }
  );
keycloakAuth.init(startVue);
